/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable max-len */
import { ChangeEvent } from 'react';
import { CoreBox, CoreCheckbox, CoreTypography } from '@youscience/core';
import { carnegieGroups } from '@common-types';

import useSchoolSelectionStore from '@store/SchoolSelectionStore';
import { getEnrollmentSize, getSchoolType } from '@utils/schoolInfographics';

import { ReducedSchoolCard } from '@components/ReducedSchoolCard';
import { ReducedCardSkeleton } from '@components/ReducedSchoolCard/ReducedCardSkeleton';

import { sxStyles, StyledWrap } from './SelectionStep2.styles';

export const SelectionStep2 = () => {
  const isPreviewCardDataLoading = useSchoolSelectionStore((state) => state.isPreviewCardDataLoading);
  const { school, isConfirmToSelection, isGrantAccessToYSProfile } = useSchoolSelectionStore(
    (state) => state.schoolSelectionData,
  );
  const {
    name,
    pictureUrl = '',
    city,
    state,
    address,
    schoolLength,
    totalStudentsEnrolled,
    cost,
  } = useSchoolSelectionStore((state) => state.schoolSelectionData.schoolPreviewInfo);

  const setSchoolSelectionData = useSchoolSelectionStore((state) => state.setSchoolSelectionData);

  const costPerYear = +cost === 0 ? '' : `${cost} AVG`;
  const schoolArrayType = carnegieGroups.get(schoolLength) as number[];
  const schoolAddress = `${address}. – ${city}, ${state}, US`;

  const handleCheckBoxChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    void setSchoolSelectionData({ [event.target.value]: checked });
  };

  return (
    <StyledWrap>
      <CoreTypography data-testid="step2Subtitle" sx={sxStyles.subtitle} variant="body2">
        {`Please confirm that you are currently enrolled at ${school?.label}. If you would like to share your YouScience
        profile with ${school?.label}, you can check the second box, however, this is optional and can be changed at
        anytime.`}
      </CoreTypography>

      {isPreviewCardDataLoading ? (
        <ReducedCardSkeleton isHideActions />
      ) : (
        <ReducedSchoolCard
          title={name}
          pictureUrl={pictureUrl}
          schoolType={getSchoolType(schoolArrayType[0])}
          enrollmentSize={getEnrollmentSize(totalStudentsEnrolled)}
          costPerYear={costPerYear}
          address={schoolAddress}
          isHideActions
        />
      )}

      <CoreBox sx={sxStyles.checkBoxesWrap}>
        <CoreBox sx={sxStyles.checkBox}>
          <CoreCheckbox
            data-testid="isConfirmToSelection"
            checked={isConfirmToSelection}
            value="isConfirmToSelection"
            onChange={handleCheckBoxChange}
          />

          <CoreTypography data-testid="isConfirmToSelectionText" sx={sxStyles.checkBoxTitle} variant="body2">
            {`I confirm that I’m enrolled in ${school?.label}.`}
          </CoreTypography>
        </CoreBox>

        <CoreBox sx={sxStyles.checkBox}>
          <CoreCheckbox
            data-testid="isGrantAccessToYSProfile"
            checked={isGrantAccessToYSProfile}
            value="isGrantAccessToYSProfile"
            disabled={!isConfirmToSelection}
            onChange={handleCheckBoxChange}
          />

          <CoreTypography data-testid="isGrantAccessToYSProfileText" sx={sxStyles.checkBoxTitle} variant="body2">
            {`Please grant ${school?.label} access to my YouScience profile. I understand that employees
            of ${school?.label} will have access to my personal YouScience profile to use in providing me
            academic and career counseling. (optional)`}
          </CoreTypography>
        </CoreBox>
      </CoreBox>
    </StyledWrap>
  );
};
